import { useState, MouseEvent } from 'react';

import { GroupButtonProps, GroupButtonStyledProps } from './type';
import { getUniqueKey } from '../utils';
import { GroupButtonWrapper, GroupButtonStyled } from './styled';

const GroupButtonComponent = ({ ...props }: GroupButtonStyledProps) => {
  const { onClick, label, active: activeProps, orientation, ...rest } = props;
  const [active, setActive] = useState<boolean>(activeProps || false);

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    if (onClick) onClick(e);
    setActive(!active);
  };

  return (
    <GroupButtonStyled
      {...rest}
      orientation={orientation || 'horizontal'}
      active={active}
      key={getUniqueKey()}
      onClick={handleClick}
    >
      {label}
    </GroupButtonStyled>
  );
};

const GroupButton = ({ ...props }: GroupButtonProps) => {
  const { data, padding, gap, orientation, ...rest } = props;
  if (!data || data.length === 0) return null;
  return (
    <GroupButtonWrapper gap={gap} orientation={orientation}>
      {data.map((item) => (
        <GroupButtonComponent
          key={getUniqueKey()}
          gap={gap}
          orientation={orientation}
          padding={padding}
          {...item}
          {...rest}
        />
      ))}
    </GroupButtonWrapper>
  );
};

GroupButton.defaultProps = {
  gap: '0px',
  orientation: 'horizontal',
  padding: '0px',
};

export default GroupButton;
